import { compact, map } from 'lodash';
import VerificationsIdentity from '../tool/VerificationsIdentity';
import VerificationsInterviewDetails from '../tool/VerificationsInterviewDetails';
import VerificationsEmployment from '../tool/VerificationsEmployment';
import VerificationsCommon from '../tool/VerificationsCommon';
import type { IRiskInsuranceComplianceVerifications } from './RiskInsuranceComplianceVerifications.interface';

export default class RiskInsuranceComplianceVerifications
  implements IRiskInsuranceComplianceVerifications {
  identities: Array<VerificationsIdentity>;
  interviewDetails: VerificationsInterviewDetails;
  employmentVerification: VerificationsEmployment;
  incomeVerification: VerificationsCommon;
  livingExpenses: VerificationsCommon;

  static build = (data: IRiskInsuranceComplianceVerifications) =>
    new RiskInsuranceComplianceVerifications(data);

  static blank = () => new RiskInsuranceComplianceVerifications();

  /**
   * Constructor
   * @param {IRiskInsuranceComplianceVerifications} data
   */
  constructor(data?: IRiskInsuranceComplianceVerifications) {
    this.identities = map(compact(data?.identities), (obj) => new VerificationsIdentity(obj));
    this.interviewDetails = new VerificationsInterviewDetails(data?.interviewDetails);
    this.employmentVerification = new VerificationsEmployment(data?.employmentVerification);
    this.incomeVerification = new VerificationsCommon(data?.incomeVerification);
    this.livingExpenses = new VerificationsCommon(data?.livingExpenses);
  }
}
